<script>
/**
 * @description Компонент анимации бокового скольжения.
 * @type {Vue}
 */
export default {
  functional: true,
  render(createElement, context) {
    const options = {
      props: {
        name: 'side-slide-left-to-right-transition',
      },
    };
    return createElement('transition', options, context.children);
  },
};
</script>
<style>
.side-slide-left-to-right-transition-enter,
.side-slide-left-to-right-transition-leave-to {
  transform: translateX(-100%);
}
.side-slide-left-to-right-transition-enter-active,
.side-slide-left-to-right-transition-leave-active {
  transition: transform .3s ease;
}
</style>
